import { render, staticRenderFns } from "./DatepickerMonthViewOnly.vue?vue&type=template&id=87947456&"
import script from "./DatepickerMonthViewOnly.vue?vue&type=script&lang=js&"
export * from "./DatepickerMonthViewOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports